import BackofficeApi from "../api/BackofficeApi";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Establishment from "../model/Establishment";

import { PopinaAtionType } from "../constant/ActionConstant";
import Environment from "../../utils/Environement";
import PopinaRestaurant from "../model/popina/PopinaRestaurant";

class PopinaActionCreator {
    private api: BackofficeApi

    constructor() {
        this.api = new BackofficeApi(Environment.isDev, Environment.isPopina);
    }

    async fetchPopinaCarte(establishment: Establishment) {
        try {
            const res = await this.api.fetchPopinaCarteWithEstablishment(establishment.token);
            AppDispatcher.dispatch({
                'type': PopinaAtionType.SET_POPINA_CARTE,
                'data': new PopinaRestaurant(res.data),
            });
            return;
        }
        catch (e) {
            throw e;
        }
    }
}

const popinaActionCreator = new PopinaActionCreator();
export default popinaActionCreator;